import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ChallengeService } from '../../services/challenge.service';
import { createPvpQueueButton } from '../../services/pvp-queue-button';
import { MobileScaleService } from '../../services/mobile-scale.service';
import { FormatSegmentComponent } from '../format-segment/format-segment.component';

@Component({
  selector: 'app-battle-actions',
  imports: [FormatSegmentComponent],
  templateUrl: './battle-actions.component.html',
  styleUrls: ['./battle-actions.component.css', './battle-actions.component.mobile.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BattleActionsComponent {
  // undefined while the team is still loading (button shows a loading shimmer).
  readonly hasTeam = input<boolean | undefined>(undefined);
  readonly challengePending = input<boolean>(false);
  // Stack the two CTAs vertically instead of side-by-side (home's sidebar).
  readonly stack = input<boolean>(false);
  readonly cpuBattle = output<void>();
  readonly customGame = output<void>();
  readonly cancelChallenge = output<void>();

  protected readonly challenge = inject(ChallengeService);
  protected readonly mobile = inject(MobileScaleService);

  protected readonly pvpButton = createPvpQueueButton({
    challenge: this.challenge,
    hasTeam: this.hasTeam,
    cancelChallenge: () => this.cancelChallenge.emit(),
  });
}
